// src/pages/Education/columns.jsx
// Колонки журнала (antd Table). Согласованы со сводной таблицей дэшборда UC.13.01.
// Числовые колонки — выравнивание вправо, tabular-nums, «—» при отсутствии данных.
import React from 'react';
import { OccPill, ActivePill } from './Pill';
import { dictLabel, nameOf, addrOf, formatNum, localityKindLabel } from './helpers';
import { occState, occDeviation, STATE_I18N_KEY } from './occupancy';

const Dash = () => <span className="ddo-dash">—</span>;
const numCell = (n) => {
  const s = formatNum(n);
  return s == null ? <Dash /> : s;
};

/**
 * buildColumns({ t, lang, meta })
 *   t    — функция подписи (k) => строка на текущем языке
 *   lang — 'ru' | 'kk'
 *   meta — из /meta (словари + пороги)
 */
export function buildColumns({ t, lang, meta }) {
  const normMin = (meta && meta.thresholds && meta.thresholds.occ_norm_min) || 0.9;

  return [
    {
      title: t('colName'),
      key: 'name',
      render: (_, r) => (
        <div className="ddo-nm">
          {nameOf(r, lang)}
          <div className="ddo-addr">{addrOf(r, lang)}</div>
        </div>
      ),
    },
    {
      title: t('colLoc'),
      key: 'loc',
      render: (_, r) => (
        <div>
          {r.locality}
          <div className="ddo-sub">{localityKindLabel(r.locType, lang)}</div>
        </div>
      ),
    },
    { title: t('colType'), key: 'type', render: (_, r) => dictLabel(meta, 'type', r.type, lang) },
    { title: t('colLang'), key: 'lang', render: (_, r) => dictLabel(meta, 'lang', r.lang, lang) },
    { title: t('colForm'), key: 'form', render: (_, r) => dictLabel(meta, 'form', r.form, lang) },
    {
      title: t('colSeats'),
      key: 'seats',
      align: 'right',
      className: 'ddo-num',
      render: (_, r) => numCell(r.seats),
    },
    {
      title: t('colKont'),
      key: 'kont',
      align: 'right',
      className: 'ddo-num',
      render: (_, r) => numCell(r.kont),
    },
    {
      title: t('colDev'),
      key: 'deviation',
      align: 'right',
      className: 'ddo-num',
      // deviation считает сервер; фоллбэк — та же формула (мощность − факт), что в форме.
      render: (_, r) => numCell(r.deviation != null ? r.deviation : occDeviation(r.seats, r.kont)),
    },
    {
      title: t('colNapr'),
      key: 'napr',
      align: 'right',
      className: 'ddo-num',
      render: (_, r) => numCell(r.napr),
    },
    {
      title: t('colZach'),
      key: 'zach',
      align: 'right',
      className: 'ddo-num',
      render: (_, r) => numCell(r.zach),
    },
    {
      title: t('colState'),
      key: 'state',
      render: (_, r) => {
        const serverState = r.fill_state;

        const st =
          serverState && STATE_I18N_KEY[serverState]
            ? serverState
            : occState(r.seats, r.kont, normMin);

        return <OccPill state={st}>{t(STATE_I18N_KEY[st])}</OccPill>;
      },
    },
    {
      title: t('colActive'),
      key: 'active',
      render: (_, r) => (
        <ActivePill active={r.active}>{r.active ? t('actOn') : t('actOff')}</ActivePill>
      ),
    },
  ];
}
